import { render, staticRenderFns } from "./PProcessClassifyModal.Style#Drawer.vue?vue&type=template&id=6785acba&scoped=true&"
import script from "./PProcessClassifyModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./PProcessClassifyModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./PProcessClassifyModal.Style#Drawer.vue?vue&type=style&index=0&id=6785acba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6785acba",
  null
  
)

export default component.exports